import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { TableCell } from '@material-ui/core';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
});

function DateAndTimePickers(props) {
  const { classes } = props;

  return (
    <form className={classes.container} noValidate>
    <TextField 
        id="datetime-local"
        label="From"
        type="datetime-local"
        defaultValue="2017-05-24T 10:30AM"
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
      />
      
<TextField
  id="datetime-local"
  label="To"
  type="datetime-local"
  defaultValue="2017-05-24T 2:30PM"
  className={classes.textField}
  InputLabelProps={{
    shrink: true,
  }}
/>
    
</form>
  );
}

DateAndTimePickers.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DateAndTimePickers);